export default __webpack_public_path__ + "static/media/plus-code.df4390da.png";